export enum EnvironmentKeys {
  apiVersion = 'apiVersion',
  apiUrl = 'apiUrl',
  collabOauthUrl = 'loginData.collabOauthUrl',
  collabAfterLogoutRedirectUrl = 'loginData.collabAfterLogoutRedirectUrl',
  collabId = 'loginData.collab_id',
  responseType = 'loginData.response_type',
  state = 'loginData.state',
  minimalInvest = 'newInvestment.minimalInvest',
  maximalRegularInvest = 'newInvestment.maximalRegularInvest',
  maximalInitialInvest = 'newInvestment.maximalInitialInvest',
  allowZeroInitialDeposit = 'newInvestment.allowZeroInitialDeposit',
  allowZeroRegularDeposit = 'newInvestment.allowZeroRegularDeposit',
  efektikaRegularInvestDefault = 'newInvestment.efektikaRegularInvestDefault',
  efektikaInitialInvestDefault = 'newInvestment.efektikaInitialInvestDefault',
  oneTimeSpecificCode = 'paymentCodes.specificOneTime',
  regularSpecificCode = 'paymentCodes.specificRegular',
  logoutAfterIdleForMinutes = 'logoutAfterIdleForMinutes',
  posthogInstanceAddress = 'posthog.instanceAddress',
  posthogOptInSiteApps = 'posthog.optInSiteApps',
  posthogProjectApiKey = 'posthog.projectApiKey',
  cookieConsentDocumentLink = 'cookieConsentDocumentLink',
  investmentQuestionaireExternalUrl = 'externalUrls.investmentQuestionaireAgain',
  amlFormExternalUrl = 'externalUrls.amlForm',
  limitForInvestmentCreateConfirm = 'limitForInvestmentCreateConfirm',
  weeklyFrequency = 'summary.investmentPeriods.weekly',
  monthlyFrequency = 'summary.investmentPeriods.monthly',
  quarterlyFrequency = 'summary.investmentPeriods.quarterly',
  unknownFrequency = 'summary.investmentPeriods.na',
  consultCommentMinLength = 'workplace.suggestionCommentMinimalLength',
  workplaceNewContractUrl = 'workplace.newContractUrl',
  bwmAppLink = 'appLinks.bwm',
  bwmWorkplaceLink = 'appLinks.workplace',
}

export enum TestEnvironmentKeys {
  testUserWorkplaceConsultUser = 'workplace_consult_user',
  testUserWorkplaceConsultPass = 'workplace_consult_pass',
}

export interface EnviromentConfig {
  production: boolean,
  configSource: string,
}
